import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { TripContextService } from '../Services/trip-context.service';
import { UserData } from '../Models/employee-and-user-data';
import {
  voyagePmsCodeFromBookingEvtCode,
  legVoyageCode,
} from '../utils/voyage-pms-code';

@Injectable({
  providedIn: 'root',
})
export class TripContextGuard implements CanActivate {
  constructor(
    private tripContextService: TripContextService,
    private router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    _state: RouterStateSnapshot,
  ): boolean {
    const raw = localStorage.getItem('userinfo');
    if (!raw) {
      this.router.navigate(['/login']);
      return false;
    }

    const userdata: UserData = JSON.parse(raw);
    const ctx = this.tripContextService.resolve(userdata);

    const allowExcursionsWhenOutsideTripWindow =
      route.routeConfig?.path === 'excursions';

    if (ctx.phase === 'pre_package' || ctx.phase === 'post_package') {
      if (allowExcursionsWhenOutsideTripWindow) {
        if (ctx.contentEvtCode) {
          userdata.evtcode = voyagePmsCodeFromBookingEvtCode(
            ctx.contentEvtCode
          );
        }
        if (ctx.contentShipId) userdata.shipid = ctx.contentShipId;
        if (ctx.contentShipName) userdata.ShipName = ctx.contentShipName;
        localStorage.setItem('userinfo', JSON.stringify(userdata));
        localStorage.setItem('shpid', String(userdata.shipid ?? ''));
        return true;
      }
      localStorage.removeItem('userinfo');
      this.router.navigate(['/login']);
      return false;
    }

    if (ctx.contentEvtCode) {
      userdata.evtcode = voyagePmsCodeFromBookingEvtCode(ctx.contentEvtCode);
    }
    if (ctx.contentShipId)   userdata.shipid = ctx.contentShipId;
    if (ctx.contentShipName) userdata.ShipName = ctx.contentShipName;

    localStorage.setItem('userinfo', JSON.stringify(userdata));
    localStorage.setItem('shpid', String(userdata.shipid ?? ''));

    return true;
  }
}
